'use strict';

angular.module('adelementAdminApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('notifications', {
                parent: 'entity',
                url: '/notifications',
                data: {
                    authorities: [],
                    pageTitle: 'adelementAdminApp.notifications.home.title'
                },
                       templateUrl: 'app/entities/notifications/notificationss.html',
                        controller: 'NotificationsController'
                ,
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('notifications');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('notifications.detail', {
                parent: 'entity',
                url: '/notifications/{id}',
                data: {
                    authorities: [],
                    pageTitle: 'adelementAdminApp.notifications.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/notifications/notifications-detail.html',
                        controller: 'NotificationsDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('notifications');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Notifications', function($stateParams, Notifications) {
                        return Notifications.get({id : $stateParams.id});
                    }]
                }
            })
            .state('notifications.new', {
                parent: 'notifications',
                url: '/new',
                data: {
                    authorities: [],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/notifications/notifications-dialog.html',
                        controller: 'NotificationsDialogController',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    userId: null,
                                    role: null,
                                    intendedUsers: null,
                                    uiUrl: null,
                                    url: null,
                                    data: null,
                                    method: null,
                                    actionable: null,
                                    inlineActionable: null,
                                    description: null,
                                    timestamp: null,
                                    status: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function(result) {
                        $state.go('notifications', null, { reload: true });
                    }, function() {
                        $state.go('notifications');
                    })
                }]
            })
            .state('notifications.edit', {
                parent: 'notifications',
                url: '/{id}/edit',
                data: {
                    authorities: [],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/notifications/notifications-dialog.html',
                        controller: 'NotificationsDialogController',
                        size: 'lg',
                        resolve: {
                            entity: ['Notifications', function(Notifications) {
                                return Notifications.get({id : $stateParams.id});
                            }]
                        }
                    }).result.then(function(result) {
                        $state.go('notifications', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    })
                }]
            })
            .state('notifications.delete', {
                parent: 'notifications',
                url: '/{id}/delete',
                data: {
                    authorities: [],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/notifications/notifications-delete-dialog.html',
                        controller: 'NotificationsDeleteController',
                        size: 'md',
                        resolve: {
                            entity: ['Notifications', function(Notifications) {
                                return Notifications.get({id : $stateParams.id});
                            }]
                        }
                    }).result.then(function(result) {
                        $state.go('notifications', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    })
                }]
            });
    });
